var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appFlag)?_c('div'):(_vm.active)?_c('div',{staticClass:"intro"},[(_vm.imgFlag == 0 || !_vm.imgFlag)?_c('TypeOneIntro'):(_vm.imgFlag == 1)?_c('TypeTwoIntro'):_vm._e(),(_vm.showSingleBtnDialog)?_c('SingleBtnDialog',{attrs:{"messageType":_vm.messageType,"onClickConfirmBtn":() => {
      if (this.appFlag) {
        this.$router.push({
          name: "AppMain",
          query: { addressByLotNum: this.$route.query.addressByLotNum } // 지번주소
        })
      } else {
        _vm.requestReScan(_vm.modnPayUrl)
      }
  }}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }